'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Codons$Genetics = require("./Codons.bs.js");
var Enzyme$Genetics = require("./Enzyme.bs.js");

function toCodons(input) {
  return Codons$Genetics.display_codons(Codons$Genetics.make_codons($$Array.to_list(input.split("")))).join("--");
}

function toAACode(code, source, input) {
  var modified = $$Array.to_list(input.split(""));
  return Codons$Genetics.display_matches(Codons$Genetics.match_codons(code, modified, source)).join("--");
}

function t_of_tuple(param) {
  return {
          title: param[0],
          data: param[1],
          colorOn: param[2]
        };
}

function displayPane(strand, source, backbone, colorBases) {
  var $$process = function (s) {
    return Curry._1(Enzyme$Genetics.Poly.to_string, s).join("");
  };
  var dnaPane = function (strand) {
    var s = Curry._1(Enzyme$Genetics.Poly.toDNA, $$Array.map(Enzyme$Genetics.Poly.from_string, strand));
    var transcribedRNA = $$process(Curry._1(Enzyme$Genetics.Poly.transcribe, s));
    var replicatedDNA = $$process(Curry._1(Enzyme$Genetics.Poly.replicate, s));
    var codons = toCodons($$process(Curry._1(Enzyme$Genetics.Poly.transcribe, s)));
    var anticodons = toCodons($$process(Curry._1(Enzyme$Genetics.Poly.reverse_transcribe, Curry._1(Enzyme$Genetics.Poly.transcribe, s))));
    var aminoAcids = $$process(Curry._1(Enzyme$Genetics.Poly.transcribe, s));
    var aminoAcids1 = toAACode(/* One */3953222, source, aminoAcids);
    var aminoAcids3 = toAACode(/* Three */582861886, source, aminoAcids);
    return [
            /* tuple */[
              "Transcribed RNA",
              transcribedRNA,
              colorBases
            ],
            /* tuple */[
              "Replicated DNA",
              replicatedDNA,
              colorBases
            ],
            /* tuple */[
              "Codons",
              codons,
              colorBases
            ],
            /* tuple */[
              "Anticodons",
              anticodons,
              colorBases
            ],
            /* tuple */[
              "Amino Acids (One Letter Code)",
              aminoAcids1,
              false
            ],
            /* tuple */[
              "Amino Acids (Three Letter Code)",
              aminoAcids3,
              false
            ]
          ];
  };
  var rnaPane = function (strand) {
    var s = Curry._1(Enzyme$Genetics.Poly.toRNA, $$Array.map(Enzyme$Genetics.Poly.from_string, strand));
    var reverseTranscribedDNA = $$process(Curry._1(Enzyme$Genetics.Poly.reverse_transcribe, s));
    var codons = toCodons($$process(s));
    var anticodons = toCodons(reverseTranscribedDNA);
    var aminoAcids1 = toAACode(/* One */3953222, source, $$process(s));
    var aminoAcids3 = toAACode(/* Three */582861886, source, $$process(s));
    return [
            /* tuple */[
              "Reverse-transcribed DNA",
              reverseTranscribedDNA,
              colorBases
            ],
            /* tuple */[
              "Codons",
              codons,
              colorBases
            ],
            /* tuple */[
              "Anticodons",
              anticodons,
              colorBases
            ],
            /* tuple */[
              "Amino Acids (One Letter Code)",
              aminoAcids1,
              false
            ],
            /* tuple */[
              "Amino Acids (Three Letter Code)",
              aminoAcids3,
              false
            ]
          ];
  };
  if (backbone) {
    return $$Array.map(t_of_tuple, dnaPane(strand));
  } else {
    return $$Array.map(t_of_tuple, rnaPane(strand));
  }
}

exports.toCodons = toCodons;
exports.toAACode = toAACode;
exports.t_of_tuple = t_of_tuple;
exports.displayPane = displayPane;
/* Enzyme-Genetics Not a pure module */
